import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import { callNumberLabel } from '../../utils';

const LinkedHoldingDetails = ({
  instance,
  holdingsRecord,
  holdingLocation,
}) => {
  /** kware start edit */
  const intl = useIntl();
  const translatedLocation = intl.formatMessage({
    id: `ui-tenant-settings.locations.name.${holdingLocation.permanentLocation.name}`,
    defaultMessage: holdingLocation.permanentLocation.name,
  });
  /** kware end edit */
  const inactiveLabel = (
    <span>
      {' '}
      <em>
        <FormattedMessage id="ui-inventory.inactive" />
      </em>
    </span>
  );
  // const holdingsPermanentLocationLabel = ` ${holdingLocation.permanentLocation.name} > ${callNumberLabel(holdingsRecord)}`;

  /** kware start edit */
  const holdingsPermanentLocationLabel = ` ${translatedLocation} > ${callNumberLabel(holdingsRecord)}`;
  /** kware end edit */
  return (
    <div>
      <FormattedMessage id="ui-inventory.holdingsLabelShort" />
      <Link to={`/inventory/view/${instance.id}/${holdingsRecord.id}`}>
        {!holdingLocation.permanentLocation.isActive && inactiveLabel}
        {holdingsPermanentLocationLabel}
      </Link>
    </div>
  );
};

LinkedHoldingDetails.propTypes = {
  instance: PropTypes.object,
  holdingsRecord: PropTypes.object,
  holdingLocation: PropTypes.object,
};

export default LinkedHoldingDetails;
